import { WIX_FORMS, FORM_APP } from '@wix/app-definition-ids'

import {
  getCollectionType,
  CollectionType,
} from '@wix/wix-code-collections-api'

import { type Schema } from '@wix/wix-data-schema-types'

export const isOldFormsCollection = (collection: Schema): boolean =>
  collection.ownerAppId === WIX_FORMS

export const isFormsCollection = (collection: Schema): boolean =>
  isOldFormsCollection(collection) || collection.ownerAppId === FORM_APP

export const isDbDriverCollection = (schema: {
  storage?: Schema['storage']
}): boolean => getCollectionType(schema) === CollectionType.DB_DRIVER

export const isExternalCollection = (schema: Schema): boolean =>
  getCollectionType(schema) === CollectionType.EXTERNAL_DB_DRIVER

export const isUserCollection = (schema: Schema): boolean =>
  getCollectionType(schema) === CollectionType.USER

export const isBlocksCollection = (schema: Schema): boolean =>
  getCollectionType(schema) === CollectionType.STATIC_APP_SCHEMA
